import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPlan } from "../redux/slices/plansSlice";
import PlansAdminCards from "./PlansAdminCards";
import { Loader } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import SubscriptionPlanModal from "./SubscriptionPlanModal ";
const PlansAdminSectionCards = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { plans, loading, error } = useSelector((state) => state.plan);
  const [activeTab, setActiveTab] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    setActiveTab("plans");
    setShowModal(true);
    // Opcional: Si aún necesitas la navegación en algún caso
    // navigate("/admin/subscriptionplan"); 
  };

  useEffect(() => {
    if (plans.length === 0) {
      dispatch(getPlan());
    }
  }, [dispatch, plans.length]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gradient-to-b text-white">
        <Loader />
      </div>
    );
  }

  if (error && plans.length === 0) {
    return (
      <div className="h-screen flex justify-center items-center bg-gradient-to-b from-zinc-900 via-zinc-800 to-zinc-900 text-red-400 text-center">
        Error: {error}
      </div>
    );
  }

  return (
    <>
      {plans.length > 0 ? (
        <div className="pt-6">
          <button
            onClick={() => setShowModal(true)}
            className={`py-2 px-6 rounded-lg transition-all duration-300 ${activeTab === "plans"
                ? "bg-blue-500 text-white"
                : "bg-gray-600 text-white"
              } hover:bg-blue-600`}
          >
            Crear Plan
          </button>

          <SubscriptionPlanModal
            isOpen={showModal}
            onClose={() => setShowModal(false)}
          />
          {plans.map((plan) => {
            return <PlansAdminCards key={plan.id} plan={plan} />;
          })}
        </div>
      ) : (
        <div>
          <button
            onClick={() => setShowModal(true)}
            className={`py-2 px-6 rounded-lg transition-all duration-300 ${activeTab === "plans"
                ? "bg-blue-500 text-white"
                : "bg-gray-600 text-white"
              } hover:bg-blue-600`}
          >
            Crear Plan
          </button>
          <h2 className="flex justify-center items-center text-white">No hay planes disponibles</h2>
        </div>

      )}
    </>
  );
};

export default PlansAdminSectionCards;
